import script from "./ActivationListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivationListView.vue?vue&type=script&setup=true&lang=ts"

import "./ActivationListView.vue?vue&type=style&index=0&id=0933fd70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0933fd70"]])

export default __exports__